module.exports = __webpack_public_path__ + "img/shuidiantu.177977a9.gif";